



















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class WidgetCoin extends Vue {
  @Prop({ default: '38' }) readonly width?: string;
  @Prop({ default: '38' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
  @Prop({ default: '1' }) readonly opacityStar?: string;
}
